import { Component } from '@angular/core';
import { AnalyticsService } from './shared/analytics/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';

  constructor(analytics: AnalyticsService) {
    // Google Analytics: production only (see AnalyticsService); a no-op everywhere else.
    analytics.start();
  }
}
